module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('h1', {
    staticClass: "sgc-1",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Part One:")]), _vm._v(" "), _c('h1', {
    staticClass: "sgc-1",
    attrs: {
      "id": "heading_id_3"
    }
  }, [_vm._v("Vacation Abroad")]), _vm._v(" "), _c('p', {
    staticClass: "noind sgc-2"
  }, [_c('i', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("S")])]), _vm._v("o this is it, I said I to myself, coming down the gangplank at LeHavre ready to set foot on French soil. "), _c('i', [_vm._v("Europe!")]), _vm._v(" Though I had been preparing for it for seven days, and before that for seventy-seven years or centuries, I could scarcely believe my eyes. No child could welcome its mother with more eagerness than I welcomed the sight of Europe. At last my dream had come true. I was there, and with money in my wallet. And she was with me, Mona, perhaps not as excited as I, but radiant and looking as bizarre as ever in her flowing black cape, her eyes heavily made up, her barbaric jewellery swinging from neck and wrists.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("It wasn’t a pretty sight, the dock yards, with lumber and merchandise piled up in every direction, but it was different. And that was what I craved – something different. As we stumbled over the tracks to get to the boat train I caught sight of the purser, garbed now in civilian clothes, satchel in hand, picking his way to God knows where, perhaps the nearest bistrot. He looked like a different person now – Mister Anybody – as he mooched along. On the boat he had been somebody, witty, entertaining, a man to answer any and every question – and an excellent chess player too. Now he was just one more Frenchman, a very ordinary Frenchman, with a peak cap and trousers that were too short. Above his head floated the gray-black roofs which were to become so dear to me in time. Not a pretty picture, but solid, comfy, everything built to last, it seemed. On the whole somewhat shabby, tawdry, woe-be-gone. But that was part of the image of Europe which I had always preserved.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img2.png",
      "src": "Images/img2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Rolling toward Paris my eyes were glued to the window pane. The countryside seemed neat and orderly, the little railway stations were just as one finds them in picture books, the cows and sheep were like cows and sheep anywhere, but the humans appeared always to be draped in mourning. Now and then, usually from factory windows, the French blue sang out, a blue such as I had never seen before. Now and then the tricolor popped up, usually atop some ugly building. A beautiful flag – light, airy, joyous, and so simple in design.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Nearing Paris Mona gave me a nudge and pointed to a cluster of shimmering white buildings which overlooked the city. The Sacré Coeur. At once my heart leaped; tears came to my eyes. I don’t know why I felt such emotion – there was nothing about Sacré Coeur which had any claim on me. Perhaps it was simply the fact that it belonged to Montmartre. That was indeed a magic word for me. Montmartre.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Instantly I thought of George Moore, Van Gogh, Utrillo, of all the painters, poets, vagabonds I had ever read about. “Are we going to live there?” I asked. She didn’t think so. It was too far from the center of things. Well, I would walk there every day, I fervidly thought to myself. And where was the center, I wondered. Surely we weren’t going to live near the Opera and the American Express?")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("St. Lazare. We had arrived. I gasped as I took a quick look around. It was the rush hour and the place was jumping. I kept looking up all the time. The glass roof fascinated me. Never had I seen a railway station like this. Standing at the curb, waiting for the porter to get us a cab. I could have stayed in that spot forever. All Paris seemed to be parading before my eyes. This was it.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Suddenly I felt completely lost. It was no longer Europe, France, Paris, but a maelstrom in which I was drowning, without knowing so much as how to say ‘Help! Help!’ (It took me months, indeed. to discover that the word for ‘Help!’ is ‘"), _c('i', [_vm._v("Au secours")]), _vm._v("!’ What I thought of was ‘Alp! Alp!’ which is nightmare in some strange language. (Wasn’t it Strindberg shivering in the wintry boughs of a tree who kept yelling ‘Alp! Alp!’)")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We are threading our way through the maze of traffic, past the statue of Joan of Arc, past the Obelisk, over the bridge and on to the Boulevard St. Germain. I can’t take it in all at once, it’s too much to swallow in one gulp. All I can say is “What a city! What a city!”.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Suddenly we stop in front of a hotel – the Grand Hotel de France. She has stayed here, Mona, and seems to know the proprietress. The night porter in his green billiard cloth vest recognizes her, greets her warmly. The luggage is dragged up to our room. Immediately the man goes to the French windows and opens them up. We have a little balcony on the street, rue Bonaparte. As I step out on the balcony the church bells begin to ring. Such a beautiful way to welcome us to Paris. I listen with new ears; it is the first time in my life that the sound of church bells has meant anything to me. Soon there is sound of klaxons, and a fire engine sweeps through the narrow street. Are they real firemen? They look exactly like the ones I played with as a child. What next?")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We unpack, wash up, and set out for the boulevard to have a drink. I’m still trembling with excitement. It seems to me that everybody is staring at us. At Mona particularly. Too much make up probably. Or the clothes. Or is it that they see in her something different? We sit down at a little café, not the Deux Magots on the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img4.png",
      "src": "Images/img4.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Mona is talking now – a mile a minute. Giving me the low down on the quartier, pointing out where she ran into this one and that – Borowski, Hemingway, Kokoshka, Tihanyi. Where to eat cheaply when our money begins to give out. Which bookstores are the most exciting. Where one can see Picasso of an evening, or Marcel Duchamp. Where not to go, because there are too many Americans about. Where one can buy African sculpture – or canes such as Borowski sports. How to find one’s way around in the Metro. Where the avant-garde films are shown. Which aperitifs are the most pleasant tasting. “Try a Pernod!”, she says. I finish my beer and she orders two Pernods. “How did you say that again?” I’d like at least to be able to order myself a drink when I’m alone. “You can order in English”, she says. “Everybody speaks English around here.” “But I don’t want to talk English. I don’t want to be taken for an American.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("She laughs in my face. “You’ll always be an American”, she shouts. “Don’t try to be anything else. Besides, the French like Americans.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Good”, I said. “So long as they don’t take me for a Hun.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("The Pernod was wonderful. Seemed to clear my head.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I wouldn’t take another now”, said Mona. “Let’s eat first. I know a nice little place not far from here – on the rue Jacob. André Gide goes there some times.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I was watching the women passing by as she talked. I hadn’t seen a really striking one yet. Most of them seemed rather homely to me, though they carried themselves well.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“We’ll go the Brasserie Lipp some time”, she was saying. “There you’ll meet everyone you’ve ever heard of. It’s…”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Excuse me”, I said, “but there’s the first stunning-looking one I’ve seen so far”. I indicated a young woman standing at the curb.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Oh "), _c('i', [_vm._v("her!”")]), _vm._v(" she exclaimed. “She’s a well-known model. Poses for Soutine, I think, or maybe it’s Matisse. Rather fleshy, don’t you think? But that’s how they like ’em here.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Looks good to me”, I said. “I like a little flesh too.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I must take you to a whorehouse some time…”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Yes, a whorehouse. Women go as well as men, you know. You sit around and drink … you don’t have to go with the girls if you don’t want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I’d rather go alone. It sounds crazy to me, dragging your wife to a whorehouse.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“It’s fun”, she said. ‘Everybody does it.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Walking to the restaurant – we made a slight detour so as to take in some of the colorful streets in the neighborhood – my eyes feasted on even the tiniest details. What gorgeous streets for a man striving for something different all his life! The rue de Buci, the rue Mazarine, the rue de Seine: nothing but quaint dilapidated hotels, brilliant awnings, bars, food emporiums, art stores, bookshops, one thing piled on top another, men, women, dogs, cats, lunatics, vegetables, carcasses, bric-a-brac, treasures from Africa and Asia, paintings by poets, pastries by masters, billboards, ensigns, emblems, scarred and charred walls decorated with letters ten feet tall advertising drinks, talcum powders, tires, cheeses, what not.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We sit on the sidewalk, where one did everything apparently, depending on the weather and the time of day. Mona had to explain the various dishes to me. It seemed like an enormous menu – such a variety of meats, vegetables, cheeses, wines, liqueurs, hors d’oeuvres. I let her order for me, astonished to hear her rattle it off in French. I had always been dubious that she knew any French. Her vocabulary wasn’t very extensive, I soon discovered, but it was enough to get us by.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("What struck me most about that first meal was the animation with which people ate. They ate and talked, and laughed and joked. They not only enjoyed the food, they seemed to enjoy one another’s company. Didn’t they in America too? Only now and then, it seemed to me. Americans never impressed me as enjoying anything properly. And they were certainly deficient in the art of conversation. If only I knew what these frogs were talking about! If only I could join in!")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img7.png",
      "src": "Images/img7.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Do you get any of it?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“No, Val, it’s too fast for me. Besides, the Parisians use a lot of slang.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“It sure sounds beautiful”, I said. “And so much more vigorous than I thought. I used to think it a feminine language, all flowers and perfume.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Wait till you hear them swear.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I wouldn’t know the difference”, I recalled. “By the way, give me a couple of swear words. I’d like to know what it sounds like.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("She leaned forward and said with a grin: “"), _c('i', [_vm._v("Merde!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“What’s that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Shit. Isn’t it lovely?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Sounds rather innocuous to me. Can’t you give me something stronger?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“"), _c('i', [_vm._v("Vous êtes un con")]), _vm._v("”, she volunteered.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“What’s "), _c('i', [_vm._v("con")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Actually it means cunt, but when you say "), _c('i', [_vm._v("vous êtes un con")]), _vm._v(", what it really means is – You’re a prick!”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“That’s a strange one”, I said. “So they reverse it here. I must get a dictionary of slang.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“First you’d better get an ordinary one. And a map of the Metro.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“And you write out the names of a few good dishes for me!”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Listen, Val”, she cut in, “Just choose at random. Point with your finger. Everything’s good in France. You can’t pick a bad dish, even if you try. The same for the wines. They’re all marvellous, even the vin ordinaire. Let’s go somewhere for a coffee. I’d love a Chartreuse with my coffee. Let’s go to the Café Flore – it’s not so crowded as some of the others. Or would you like to try Montparnasse – the Dôme, for instance?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I decided that Montparnasse could wait. “Let’s stay in this quarter”, I suggested. “Pick any joint you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("The church bells began ringing again. It was entrancing. Why didn’t they sound that way at home?")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Do you remember Huysmans, Val? There’s a church a little farther up the street, probably the ugliest in Paris – St. Sulpice. Huysmans wrote about it in "), _c('i', [_vm._v("La Bas")]), _vm._v(". Paris is full of churches. The best one, in my opinion, is St. Chapelle. Next to Chartres I think it the most beautiful in France.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“What about Notre Dame?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“It’s beautiful too, but it doesn’t move me. Maybe it’s been looked at too much.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("As we took a seat on the "), _c('i', [_vm._v("terrasse")]), _vm._v(" of the Flore, Mona pointed out this one and that, all celebrities, most of them unknown to me even by name. “Each artist has his own café”, she explained. “It’s in the café he meets his friends, not at his home. Most of them don’t have a home, anyway; they live in hotel rooms or garrets. If a Frenchman invites you to his home you can take it you’ve made a real friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I like that”. I said promptly. “I means meeting one’s friends at a café rather than at home. Privacy is something we’ve never had.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img9.png",
      "src": "Images/img9.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Yes”, said Mona eagerly, “No one here thinks of barging in on you unannounced. They either telephone or send you a "), _c('i', [_vm._v("pneumatique")]), _vm._v(" – that’s like a special delivery letter, only it looks like a telegram.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“How do you like the hotel?” she added. “Isn’t it cosy? If you run short of cash just ask the woman at the desk to lend you some francs. They’re very decent about money.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“That doesn’t sound French to me”, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“You’re right. The French are not very generous, on the whole, but the people at the hotel are different. They come from the Midi, that’s the south of France. Another breed entirely.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Let’s hope we don’t run short”, said I. “We have enough now to last us a year, if we don’t get reckless.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“That’s the trouble”, said Mona. “One does get reckless over here. Too much to see, too much to do, too much to buy. You can’t resist.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Well, let’s take it easy to begin with. Jesus, I’d be happy if I did nothing more than eat and drink the way we’re doing now, and walk the streets and gape and stare.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“We don’t want to stay in Paris forever, do we?” said Mona. “There’s so much else to see. There’s Germany, Austria, Hungary, Poland, Romania…”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Hold on! Let’s get a taste of Paris first. Don’t rush me all over the map right away, "), _c('i', [_vm._v("please")]), _vm._v(". Sure, I want to go places, see things, but not all at once. "), _c('i', [_vm._v("Romania")]), _vm._v(", you say. That’s a strange one. Why Romania?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Because I have relatives there. I was born in the Carpathians, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Where was it again?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“In Bukovina.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Okay. We’ll go there one day. But not till we’ve had a good look at France, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“As you please”, she replied. “Only I know "), _c('i', [_vm._v("you")]), _vm._v(". You’ve got itchy feet.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I’d like to see the whole wide world, that’s what. But you can’t do it on a shoestring. If we had the dough. I’d say let’s go to India, China, Bali, Persia. I could go on travelling for the rest of my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“And what about writing?” she said, with a sly gleam in her eye.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“"), _c('i', [_vm._v("That")]), _vm._v(", there’s always time for that. Now we’re travelling.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img11.png",
      "src": "Images/img11.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Couldn’t you write too?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I don’t know. Maybe. We’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Maybe we’ll find just the spot to settle down in, some place where you’d feel at home… maybe in the south of France.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I wouldn’t care where it was”, I replied. “If only we had enough to live on. It would be tough trying to beg in French.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“We’re not going to beg”, said Mona defiantly. “You’re going to write and you’re going to get paid for your work. Trust me. I’ll take care of all that.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Let’s drop the subject, what do you say? I don’t want to think about money any more. Let’s just live and forget.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("The next morning we had breakfast in bed, or rather Mona did. I was already up and dressed, ready to stretch my legs; the bells were ringing again, the air was soft and balmy. Springtime in Paris: the dream of every tourist. The croissants were delicious and the dark chicory-flavoured coffee just to my taste.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“What’s the program for today?” I asked, as she made for the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I think we’ll go to see Borowski, if you don’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Just like that? No warning? I thought you had to send a what you call it first.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Not with Borowski”, she replied. “We’re old friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I waited patiently on the balcony while she made ready to go, always a long procedure with her. What a lively spectacle it was from up there on the third floor: where in America could I look down on a stream of traffic such as this? She had picked a good street for a first taste of Paris. It was alive, intimate, colorful – as gay as the tricolor itself.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“We’ll walk there”, she said. “It’s only a few blocks from here. Near the Luxembourg Gardens. He’ll be thrilled.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I wasn’t so sure he’d be thrilled to see "), _c('i', [_vm._v("me")]), _vm._v(". From all she had told me about the wonderful days and nights they had spent together, to say nothing of the gifts she had brought back from his studio, I was a bit apprehensive. I tried to convey the thought to her but she dismissed it as absurd. In the past, whenever I had been introduced to one of her lovers – “admirers”, she called them – it was never as her husband. I was usually passed off as one of her writer friends. Borowski, she had told me, treated her as a fellow artist, a writer, no less. It would be interesting to know, could I open him up, just what he thought about her writing. I also wondered what she would say when he inquired about those “gifts” she had taken with her to America.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img13.png",
      "src": "Images/img13.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("She pulled the bell rope at the garden door and in a moment there came a man’s voice – rather sharp and querulous, I thought – demanding to know who was there.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“It’s me, Mona”, she said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("With that the door was unlocked and there stood Borowski, no mistaking him, pipe in hand, beret cocked jauntily over his thick mop of iron-gray hair.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("They embraced warmly and then I was introduced – “my husband”. From the fleeting expression that passed over his face I realized that a husband was the last thing he expected her to present him with.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img14.png",
      "src": "Images/img14.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Come in, come in”, he said. “Well, so you’re back. And where is Stasia?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Before she could reply he was leading us toward the huge figures which were standing about. The weather permitting he worked outdoors. He seemed diminutive by comparison with the creations in stone and wood which surrounded him. The words bubbled out of his mouth as he expatiated on each figure in turn. He moved in and out of them rapidly like a squirrel. He talked the same way. And with an air of authority. The vitality which emanated from him was electrifying.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Mona of course was full of admiration for his work. Always lavish with her encomiums, she gushed over each piece as if nothing like it had ever been produced before. Those which she had seen before she went up to and caressed with a display of tenderness which was positively embarrassing.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“You’re just in time for lunch”, said Borowski, as he excused himself to change his clothes. He and I had hardly exchanged a dozen words, it seemed to me. He reappeared looking raunchy and dapper. Evidently he had his clothes made in England. Everything of the best.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Including the slouch hat which he wore at a rakish angle. At the door of his studio he paused a moment to select a cane; I noticed that there were at least a dozen to choose from, all distinctive and exotic.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img15.png",
      "src": "Images/img15.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We would eat on the boulevard Montparnasse, he informed us. First a drink at the Select. As we walked he mingled witticisms, stories, observations on this and that, all in rapid fire style. He was a ball of fire, no doubt about it. And a formidable adversary if one had to lock horns with him. Now and then he would shoot a question about Stasia, but hardly seemed to listen to Mona’s replies.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We sat down on the "), _c('i', [_vm._v("terrasse")]), _vm._v(" of the Select, which was already quite crowded. He nodded to various friends, shook hands with one or two, then asked us what we would like to drink.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Pernod”, said I, without stopping to think.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“No!” he said. “Let me order something more interesting. Anybody can drink Pernod. It’s vile”. He called for Saint Raphael – three of them.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I suppose you’re a writer too”, he said, suddenly addressing me.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Mona immediately explained that I was the writer she had told him about when she was here last year.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Yes, yes, of course”, he said. “You’re all writers in America, aren’t you?” He followed this up with some flippant remark about what a strange country America was. Adding that we were really becoming a pest to the European. “I suppose you will settle down and take a studio, is that it? Write the great American novel, that sort of thing.” With this a few words in French which he addressed to the air.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I felt too slow-witted to cope with these remarks. I simply grinned and sipped my Raphael.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“You must meet Calder some time”, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Who’s Calder?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("At this Borowski threw his head back and gave a loud guffaw. “How American! So you don’t know who Calder is!…Well, you’ll find out soon enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Of course you know him”, said Mona. “You’ve seen his mobiles, I’m sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Oh, that guy”, I said. “Of course I know who you mean, But I never met him.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“How about Hemingway?” I shook my head. “Steinbeck’? Dos Passos?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Just names to me”, I confessed.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I assumed that this finished me in Borowski’s eyes. It was hard to tell what he thought about anything or anybody; he had a malicious tongue and he knew how to use it. If some one came over to shake hands with him he would jump up like a Jack-in-the-Box, exchange a few words. and then as he resumed his seat he would remark with contempt or disdain: “An impossible chap…a bore”. Only in French it sounded worse because with everything he disliked he had to say it was “"), _c('i', [_vm._v("emmerdant")]), _vm._v("”. He was highly irascible too. Forever bawling the waiters out, annoyed when people brushed his shoulder in slipping by the table. Yet withal jovial, witty, always animated, always darting, bounding, pouncing.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img17.png",
      "src": "Images/img17.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We had lunch on the sidewalk outside some modest restaurant where we wouldn’t be molested, as he said. As usual, he decided what we would eat and drink, with considerable snapping of the fingers and banging of the table for attention. As he ate he dished out little anecdotes about his friends, his ordeals as a novice, between whiles recommending a film or a play that we must not fail to see. His talk fascinated me despite an innate dislike which I tried to suppress. He spoke with an accent, whether speaking English or French. But it was an accent which enhanced his words. Often he invented a word, if the right one didn’t come to mind immediately. A charming fellow, as my friend Stanley used to say.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Isn’t he wonderful?” said Mona as we were walking back to the hotel. “I told you you’d like him. And he’s a very great sculptor too…better than Rodin by far. He’s very sensitive, perhaps because of his size.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img18.png",
      "src": "Images/img18.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("That’s what makes him so cocky and aggressive. But he doesn’t mean anything by it. He’s a good friend. You can count on him.” She paused a moment. “And he likes you too, though he tried to hide it.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Jealous, no doubt”, said I.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We were walking through the Luxembourg Gardens, past the Queens of France. “There’s nothing like this anywhere”, said Mona. “Stasia and I used to come here often to eat our lunch. He liked Stasia very much.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Who did?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Borowski. He said she had enormous talent – but no discipline. He teaches, you know, in some Academy. I forget the name now. I used to go with Stasia and watch her work.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("She went on and on about Stasia, the artists they had met, their outings in the Bois de Boulogne, the "), _c('i', [_vm._v("bals musette")]), _vm._v(", the flea market, the Hotel Princesse where they lived without a cent for three weeks, and so on. I only half listened. I was thinking how strange it was that the first Frenchman, the first European I should meet was this famous sculptor, Borowski. Had I met Rodin or Bourdelle, would it have gone off so easy? I wondered vaguely if I would get to know Marcel Duchamp, or even André Gide. Too late, alas, to know Apollinaire or Modigliani.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img19.png",
      "src": "Images/img19.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Did you ever meet Cocteau?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Yes, of course”, she said. “But he’s seldom here, he lives in the south of France somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Did you ever hear of a place called "), _c('i', [_vm._v("Le Rat Mort")]), _vm._v(" ?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I think so. Why? Why do you ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Oh, it’s one of those places I’d like to see sometime. Many famous men used to gather there … Cezanne, for instance, George Moore, Zola, Rimbaud…”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Rimbaud?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Yes, and Verlaine too, probably.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I wish I had known that, Val. Stasia would go crazy to see that place. Because of Rimbaud, if nothing else.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“We’ll look it up sometime.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("As we reached the hotel she said, “Wait a minute, let’s cross the street. I want to show you a little street where Balzac had his printing shop.” She steered me to the rue Visconti. “And on the next block, I think it is, Oscar Wilde used to live. Oh yes, and I forgot to tell you when we were at Borowski’s that right near there Strindberg used to live. There’s a plaque outside the hotel giving the date.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Who hasn’t lived here at some time or other?” I said to myself.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We strode back to the hotel to take a nap. The day was young yet. When the bells began to ring it would be time for an aperitif. I preferred Pernod to the Raphael; it put lead in your pencil.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("It was hard to get to sleep immediately. Seemed to me the room smelled musty. How many thousands of people had slept in this room, I wondered. Everything looked worn, worn but clean. The big mirror showed streaks of quicksilver – too many people had stared into it. But what a comfortable bed! One drowned in it. I opened the little compartment in the night table just to see. Sure enough, there was a pisspot standing there. That and the bidet – indispensable. As for the bath, that was down the hall somewhere. You had to notify the maid. when you wanted to take one. You paid extra for it too. You paid for soap and matches also, I noticed. And whatever you did always involved a tip. Even when you went to the toilet in a café. I didn’t mind; it seemed rather cute. Kept money in circulation. If by paying extra we could have had some decent towels I would have ordered some. According to Mona, there were no other kind; only when you took a bath could you have a Turkish towel. Besides, you had to use your towels discreetly; they didn’t change them every day, as in America.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("The sound of the bells woke me up. I dashed to the balcony to hear them better. Again the fire engines passed. Must have a lot of fires in Paris. Or maybe they were just practising. Anyway, looking up and down the street, I was entranced by the milk and gray aspect of the walls. And what huge doorways! What locks and bolts! And the iron shutters that were rolled down at close of day. When they closed down they closed down here. "), _c('i', [_vm._v("Fermé")]), _vm._v(". No two ways about it.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img21.png",
      "src": "Images/img21.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("This time we took a seat at the corner, just a block below the Deux Magots. There was hardly room between the tables and the gutter for a pedestrian to pass. We ordered our Pernod and settled down to observe the scene. Just as the waiter appeared Mona caught sight of a man crossing the street; his back was toward us. She jumped up and ran after him. He flung his arms around her and kissed her. She dragged him back to the café.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“This is Michonze”, she said, putting an arm around his shoulder. “He’s the poorest painter in all Paris. And the greatest friend any one could ask for. Sit down, have a drink with us!”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“With pleasure”, he said, in perfect English. “So you got married in the meantime? Congratulations!”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“We’ve been married for years”, said Mona. “Only I never told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("He smiled and said: “Isn’t she wonderful? Always up to some new trick. How long are you staying? I’d like to show you what I’ve done since you left. It’s not much, of course … you know what my life is. Still, I manage to knock out a painting now and then.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img22.png",
      "src": "Images/img22.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Of course we want to see your work”, said Mona. “Don’t we, Val? One day you’re going to be famous.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“One day”, he echoed. “If I live that long.” With this he began talking about Modigliani, whom he had known, and Soutine, whom he spoke of as a pal. Soutine was doing well now, but in bad health. Too much carousing, too much starvation. Max Ernst’s name was on his lips. Another good friend. They had been through the worst together.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“What about Reichel?” said Mona. “And Tihanyi? Are they still around?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Why not?” he said. “You can’t kill them off as easily as that.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Where did you learn English?” I asked after a while. “You seem to speak it perfectly.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“English! That came easy. I learned it from you Americans. It’s the Americans who keep me alive. Ask Mona.” He went on to say that languages came easy to him; he knew six or seven at least. He turned to Mona. “You know whom I can’t understand even to this day? He drives me crazy too. "), _c('i', [_vm._v("Tihanyi")]), _vm._v(".” He explained to me that Tihanyi was a Hungarian who was deaf. A good painter too. He taught himself to learn French and English, German too … perhaps other languages, who knows? But since he couldn’t hear his own words he had no idea what his French or English sounded like. It was absolutely atrocious, a sort of baboon’s tongue. “And if you understand him he gets angry.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img23.png",
      "src": "Images/img23.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“It’s true”, said Mona. “But he’s adorable. You can’t help liking him with all his faults. I always pretend to understand. But sometimes that makes him angry too.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“And how is Stasia?” asked Michonze.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“She’s fine”, Mona replied.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Where is she now?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I don’t know. Maybe she’s here in Paris.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("She quickly changed the subject. “Why don’t we go and have a look at your paintings? Maybe you’d like to have dinner with us?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Excellent”, said Michonze. “If we have time I’ll do a portrait of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“In that case I’ll run back to the hotel”, said Mona, “and put on my velvet cape and my hat that Val likes so much.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("She was back in a jiffy and off we started to Michonze’s "), _c('i', [_vm._v("atelier")]), _vm._v(". It was on the rue Vaugirard, top floor. A foul, smelly building, dark as a prison. He didn’t even have a room; his "), _c('i', [_vm._v("atelier")]), _vm._v(" was the bit of hallway from the stairs to the W.C. Just big enough for a cot, a chair and a table. By the light of a dim electric bulb we inspected his work. I didn’t know what to make of the canvases; all I could think of was that they reminded me of Russia and Poland where he had come from originally.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Soon he was busy making Mona’s portrait. He was especially captivated by the hat; he seemed to concentrate on that rather than her face. It took him only about three-quarters of an hour to complete the job. It was a good likeness and rather flattering. Mona thought it wonderful. “I’m taking it”, she said, and with that drew a fifty dollar bill from her purse. I thought she was being rather stingy, but Michonze appeared to think it more than adequate. “Maybe I’ll be able to get out of this place now”, he said, stuffing the bill in his pocket. “Let me take you people to dinner!” We wouldn’t hear of that, naturally. “Well then, let me "), _c('i', [_vm._v("give")]), _vm._v(" you a painting.” He dragged out some canvases from under the cot. “Choose anything you like”, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("It took her another twenty minutes to decide which one she preferred. Finally he said: “Let’s get out of here. You can come back another day and pick one out. The portrait has to dry first anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("He selected a modest restaurant on the rue de Seine, a place where students ate. It was gay, noisy, and the food was excellent. He promised to give us the addresses of similar restaurants so that we wouldn’t waste our money.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We sauntered slowly back to Montparnasse and again installed ourselves on the "), _c('i', [_vm._v("terrasse")]), _vm._v(" of the Select. Hardly had we taken our seats when some one slapped me on the back, saying: “"), _c('i', [_vm._v("Miller")]), _vm._v(", how "), _c('i', [_vm._v("are")]), _vm._v(" you? My God, how did "), _c('i', [_vm._v("you")]), _vm._v(" get here?” I looked up and so help me if it wasn’t my old friend Johnny Dunn of the Cosmodemonic Telegraph days.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img25.png",
      "src": "Images/img25.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Sit down”, I said, “and have a drink with us.” I presented him to Michonze and to Mona.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“This is the man who first told me about Rimbaud”, I said to Mona. “I’ve told you about him often, don’t you remember? How he met his former boss outside the Flatiron Building one day while working as a messenger and the next week he was in the Queen of Romania’s winter palace in the Carpathians.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“"), _c('i', [_vm._v("Miller")]), _vm._v("”, said Dunn, “I never thought you’d make it. What luck to meet you here.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I never would have made it”, said I, “if it weren’t for her”, nodding toward Mona.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“You don’t have to tell me”, he said, with a twinkle in his eye. “Let me congratulate you.” He turned to Mona. “What an extraordinary voice you have”, he said. “Are you an actress by chance?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I was once”, said Mona. “Not much of a one though.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I would say you could be a very great actress”, said Dunn. He turned to me. “I have a friend with me … over there”, he said, pointing to a table nearby. “We’re going to the theatre tonight. Could I invite you to come with your wife?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Is it in English?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“No, it’s in French. A farce, with Max Dearly. I don’t suppose you know his name. I’m crazy about him.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img26.png",
      "src": "Images/img26.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Mona immediately decided against it. “But you go, Val”, she urged. “You’ll enjoy it.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("I decided I would. It was getting late for the theatre. We collected his lady friend and hopped a cab.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Miller”, he said, “you don’t know what a lucky man you are. To have a wife like that – it’s incredible. And what a voice! Every time she opens her mouth I feel as if I were going to have an ejaculation. I wouldn’t leave a woman like that alone for two minutes … in Paris … or anywhere … if I were in your boots.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“And what are you doing here?” I asked. “I thought you lived in Scheveningen, or is it the Hague?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I do”, he said. “We’re having a little vacation. We’re leaving for the country in a few days. Maybe you’d like to join us. Have you learned any French yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I only arrived yesterday”, I said. “Or was it the day before? Seems like I’ve been here a week already.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I hope you stay here”, he said. “Don’t ever go back to America. What a dreadful place! I never was so miserable in my life as in New York. Thanks to you I got out alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img27.png",
      "src": "Images/img27.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("We pulled up at the theatre, bought another ticket and rushed in. The curtain was just going up. “Don’t try to understand the words”, he whispered, as we took our seats. “Just look!’ I’ll explain it all to you later.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("It was a bedroom farce, as best I remember, with nothing to recommend it except Max Dearly whom every one seemed to think was delicious. I had all I could do, by the time the play was half over, to keep my eyes open. I didn’t understand a word.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("He drove me back to the hotel immediately after the show; we agreed to meet again in a day or two. The woman he called his mistress had hardly breathed a word. She was half Dutch, half Javanese, he said. “And wonderful in bed”, he whispered. I never did find out what the play was about.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Mona was creaming her face as I walked in. I was rather surprised that she was back so early. “You must have been bored”, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“God, no! I had a marvellous time. You had hardly left when Varese appeared, then Kokoschka, and finally Marcel Duchamp. The conversation was just marvellous…”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“In what language?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“In English. They all speak English, except Vlaminck. He can speak it too, I’m sure, but he didn’t want to…”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“And how was the play? Did you enjoy it?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img28.png",
      "src": "Images/img28.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I fell asleep in the last act.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I’ll take you to the "), _c('i', [_vm._v("Grand Guignol")]), _vm._v(" some night. I’ll guarantee you won’t fall asleep there. By the way, what does your friend do now? He’s a rather strange person, I thought.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“How do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Rather degenerate, if you ask me.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I wouldn’t say "), _c('i', [_vm._v("that")]), _vm._v(". Certainly he’s been around, seen everything, tried everything. A man of the world, you might say. I learned a lot from him. He’s one of the reasons I’m here, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Does he write or paint?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“No, he doesn’t have to. He just lives. Speaks about nine languages you know. Including Bulgarian, Serbian and Arabic. No Hungarian, though. I can still see the two of us hanging on to a strap in the subway and him telling me about writers like Apollinaire, Gottfried Benn, Paul Valery, Max Jacob. He has a wonderful gift for describing places too. And what places! He’s lived in almost every capital of the world and he knows them inside out. It all started with the war and his ability to memorize lengthy documents which he carried in his noodle from one country to another. He knows a bit about art as well. That’s how he came to America, if you remember. He was trying to unload a case of precious masterpieces and got caught with his pants down. It was a lucky day for me when he came to my office to ask for a messenger job. That wife of mine couldn’t stand him, of course. He was too sophisticated, too cynical, she said. But then she never did like any of my friends, unless it was Ulric. Wouldn’t it be wonderful if "), _c('i', [_vm._v("he")]), _vm._v(" were to show up here one day, the bugger?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img29.png",
      "src": "Images/img29.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“I certainly hope we don’t run into your friend MacGregor. I can’t stand that man.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Christ, I forgot all about "), _c('i', [_vm._v("him")]), _vm._v(". He’s about due now, isn’t he? That is, if he went through with his plan. I wonder how he made out with that gal of his.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Val, if we run into him I’m walking away. I don’t see how you put up with him all these years.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“We’re going to run into a lot of people we don’t want to meet, I’m afraid. Especially if we go to the Dôme. That’s the first place they head for, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img30.png",
      "src": "Images/img30.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Michonze virtually lives there”, said Mona. “He’s there day and night, he tells me.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“When does he paint then?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“That’s it, "), _c('i', [_vm._v("when")]), _vm._v("? He’s only one of thousands who spend the whole day searching for a meal. That’s why I bought the portrait. He may not sell another painting for six months.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Well, if one has to starve I think I’d rather starve here than anywhere else. At least there are benches to sit down on once in a while. And if you have the price of a coffee you can go to a café and keep warm. You can even write your letters there, I notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Let’s not talk about starving, Val. Time enough for that when we get home.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("As we climbed into bed I asked if she had heard from Pop yet.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“How could I? We have to go to the American Express for our mail. Maybe we’ll go tomorrow. Then I can show you the Palais Royal, the Tuileries, and the rue de la Paix.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Fuck the rue de la Paix! I’m not buying any jewellery yet. I’d rather see Les Halles or Notre Dame. Or what’s that church you were raving about…Ste. Chapelle, was-it?”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img31a.png",
      "src": "Images/img31a.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Yes, yes. Ste, Chapelle. By all means let’s go there tomorrow. You’ll never see the like of it again. It takes your breath away. We should go to the bird market too; it’s not far from there.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img31b.png",
      "src": "Images/img31b.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("“Okay”, I said. “But one of these days I intend to take a stroll all by my lonesome. It’ll be fun to get lost in a city like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img32.png",
      "src": "Images/img32.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7866e038","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_part1.vue
// module id = 72
// module chunks = 0